import { UserSessionDocument } from '__generated__/graphql';
import { preloadQuery } from 'setupClient';

export const authQueryRef = preloadQuery(UserSessionDocument, { errorPolicy: 'all' });
